import { i18n } from '../../i18n/translate.js';
import { ConfirmationModal } from '../ConfirmationModal/index.js';
import PropTypes from 'prop-types';
import React from 'react';
var CancelConfirmModal = function CancelConfirmModal(props) {
  var _props$body = props.body,
    body = _props$body === void 0 ? i18n.t('Are you sure you want to discard all your changes?') : _props$body,
    _props$branded = props.branded,
    branded = _props$branded === void 0 ? false : _props$branded,
    _props$cancelButtonTe = props.cancelButtonText,
    cancelButtonText = _props$cancelButtonTe === void 0 ? i18n.t('No') : _props$cancelButtonTe,
    _props$confirmButtonT = props.confirmButtonText,
    confirmButtonText = _props$confirmButtonT === void 0 ? i18n.t('Yes') : _props$confirmButtonT,
    container = props.container,
    _props$onCancelClose = props.onCancelClose,
    onCancelClose = _props$onCancelClose === void 0 ? function () {} : _props$onCancelClose,
    _props$title = props.title,
    title = _props$title === void 0 ? i18n.t('Discard unsaved changes') : _props$title;
  return /*#__PURE__*/React.createElement(ConfirmationModal, {
    branded: branded,
    cancelButtonText: cancelButtonText,
    canClickOff: true,
    confirmButtonText: confirmButtonText,
    container: container,
    onCancel: function onCancel() {
      return onCancelClose(false);
    },
    onConfirm: function onConfirm() {
      return onCancelClose(true);
    },
    show: props.show,
    title: title
  }, /*#__PURE__*/React.createElement("div", null, body));
};
CancelConfirmModal.displayName = "CancelConfirmModal";
CancelConfirmModal.propTypes = {
  body: PropTypes.string,
  branded: PropTypes.bool,
  cancelButtonText: PropTypes.string,
  confirmButtonText: PropTypes.string,
  container: PropTypes.node,
  onCancelClose: PropTypes.func.isRequired,
  show: PropTypes.bool,
  title: PropTypes.string
};
export { CancelConfirmModal };